module.exports = __webpack_public_path__ + "img/default.765d5692.svg";